import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from '../pages/public/Login';
import Dashboard from '../pages/admin/Dashboard';
import PrivateRoute from './PrivateRoute';
import { ViewProvider } from '../components/layout/ViewContext'; // Import ViewProvider
import ForgotPassword from '../pages/public/ForgotPassword';
import ResetPassword from '../pages/public/ResetPassword';
import CompanyInfoList from '../pages/admin/companyInfo/List';
import CompanyInfoCreate from '../pages/admin/companyInfo/Create';
import CompanyInfoEdit from '../pages/admin/companyInfo/Edit';
import UsersList from '../pages/admin/users/List';
import UserCreate from '../pages/admin/users/Create';
import UserEdit from '../pages/admin/users/Edit';
import AuditLogList from "../pages/admin/auditLogs/List";
import Unsubscribe from "../pages/public/Unsubscribe";
import BulkEmailList from "../pages/admin/bulkEmail/List";
import BulkEmailCreate from "../pages/admin/bulkEmail/Create";
import BulkEmailEdit from "../pages/admin/bulkEmail/Edit";

import MemberList from '../pages/admin/member/List';
import MemberCreate from '../pages/admin/member/Create';
import MemberEdit from '../pages/admin/member/Edit';

import LeadList from '../pages/admin/lead/List';
import LeadCreate from '../pages/admin/lead/Create';
import LeadEdit from '../pages/admin/lead/Edit';

import ClientList from '../pages/admin/client/List';
import ClientCreate from '../pages/admin/client/Create';
import ClientEdit from '../pages/admin/client/Edit';

// Import route here

const AppRouter = () => {
    return (
        <ViewProvider>
            {' '}
            {/* Wrap all routes in the ViewProvider */}
            <Router>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/unsubscribe" element={<Unsubscribe />} />

                    {/* Protected admin routes */}
                    <Route
                        path="/admin/dashboard"
                        element={
                            <PrivateRoute>
                                <Dashboard />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/auditlogs"
                        element={
                            <PrivateRoute>
                                <AuditLogList />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/client"
                        element={
                            <PrivateRoute>
                                <ClientList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/client/create"
                        element={
                            <PrivateRoute>
                                <ClientCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/client/:id"
                        element={
                            <PrivateRoute>
                                <ClientEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/companyinfo"
                        element={
                            <PrivateRoute>
                                <CompanyInfoList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/companyinfo/create"
                        element={
                            <PrivateRoute>
                                <CompanyInfoCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/companyinfo/:id"
                        element={
                            <PrivateRoute>
                                <CompanyInfoEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/bulkemails"
                        element={
                            <PrivateRoute>
                                <BulkEmailList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/bulkemails/create"
                        element={
                            <PrivateRoute>
                                <BulkEmailCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/bulkemails/:id"
                        element={
                            <PrivateRoute>
                                <BulkEmailEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/users"
                        element={
                            <PrivateRoute>
                                <UsersList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/users/create"
                        element={
                            <PrivateRoute>
                                <UserCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/users/:id"
                        element={
                            <PrivateRoute>
                                <UserEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/members"
                        element={
                            <PrivateRoute>
                                <MemberList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/members/create"
                        element={
                            <PrivateRoute>
                                <MemberCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/members/:id"
                        element={
                            <PrivateRoute>
                                <MemberEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/leads"
                        element={
                            <PrivateRoute>
                                <LeadList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/leads/create"
                        element={
                            <PrivateRoute>
                                <LeadCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/leads/:id"
                        element={
                            <PrivateRoute>
                                <LeadEdit />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/clients"
                        element={
                            <PrivateRoute>
                                <ClientList />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/clients/create"
                        element={
                            <PrivateRoute>
                                <ClientCreate />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/clients/:id"
                        element={
                            <PrivateRoute>
                                <ClientEdit />
                            </PrivateRoute>
                        }
                    />



                </Routes>
            </Router>
        </ViewProvider>
    );
};

export default AppRouter;
